import { Box } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import React, { useState } from "react";
import DeleteBtn from "src/components/shared/DeleteBtn";
import PrintBtn from "src/components/shared/PrintBtn";
import UpdateBtn from "src/components/shared/UpdateBtn";
import ViewBtn from "src/components/shared/ViewBtn";
import appConfig from "src/config/env";
import { COMMOM_STATUS, orderStatusFormatted } from "src/constant";
import useAppGlobal from "src/context/useAppGlobal";
import useProcessLogDetail from "src/hooks/process-log/useProcessLogDetail";
import useWarehouseTransferExport from "src/hooks/warehouse-transfer/useWarehouseTranferExport";
import useWTRemove from "src/hooks/warehouse-transfer/useWTRemove";
import ExportInfoDialog from "./ExportInfoDialog";
import ConfirmComp from "src/components/shared/ConfirmComp";
import TempExport from "./TempExport";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";

export default function ExportActionGroup({ item }) {
  const permissionCheck = useRoleCheck();
  const [logId, setLogId] = useState(null);
  const { handleOpenDialog, closeDialog } = useAppGlobal();
  const { trigger: removeWT } = useWTRemove();
  const { trigger: printWT } = useWarehouseTransferExport();
  const { mutate } = useProcessLogDetail(logId);

  const handleDelete = async () => {
    const res = await removeWT({
      pathIncluded: {
        id: item?._id,
      },
    });
    if (res?.success) {
      closeDialog();
      return enqueueSnackbar("Xoá phiếu thành công", { variant: "success" });
    } else {
      return enqueueSnackbar(res?.error?.message, { variant: "error" });
    }
  };

  const handleGetLog = (logIdParam) => {
    const logIdToUse = logIdParam || logId;
    if (!logIdToUse) return;

    const timeOut = setInterval(async () => {
      try {
        const res = await mutate();
        if (res?.success) {
          if (res.data.status === COMMOM_STATUS.done) {
            if (Array.isArray(res.data?.urls)) {
              res.data.urls.forEach((v) => {
                window.open(`${appConfig.API_FILE}/${v}`, "_blank");
              });
            }
            clearInterval(timeOut);
          }

          if (res.data.status === COMMOM_STATUS.error) {
            enqueueSnackbar("Không xuất được đơn", { variant: "error" });
            clearInterval(timeOut);
          }
        }
      } catch (err) {
        clearInterval(timeOut);
      }
    }, 1000);
  };

  const handlePrint = async () => {
    const res = await printWT({
      body: {
        warehouseTransferIds: [item?._id],
        transferFileType: orderStatusFormatted.Exported,
      },
    });
    if (res?.success) {
      setLogId(res?.data?._id);
      handleGetLog(res?.data?._id);
      return enqueueSnackbar("Tiến hành xuất phiếu...", { variant: "success", className: "notistack-confirm" });
    } else {
      return enqueueSnackbar(res?.error?.message ?? res?.error?.message, {
        variant: "error",
      });
    }
  };

  const handleView = () => {
    handleOpenDialog({
      title: "Xem thông tin phiếu xuất kho",
      content: (
        <ExportInfoDialog
          id={item?._id}
          onPrint={handlePrint}
        />
      ),
      size: "xl",
    });
  };

  const handleUpdate = () => {
    handleOpenDialog({
      content: (
        <TempExport
          updateItem={item}
          title="Chỉnh sửa lệnh xuất kho"
        />
      ),
      size: "xl",
    });
  };

  const handleDeleteDialog = () => {
    handleOpenDialog({
      content: (
        <ConfirmComp
          custom={{
            label: "Vui lòng xác nhận bạn muốn xoá phiếu này không",
          }}
          onConfirm={handleDelete}
        />
      ),
      size: "md",
    });
  };

  const action = () => {
    switch (item?.statusOut) {
      case orderStatusFormatted.Pending:
        return (
          <Box
            display="flex"
            gap="6px"
            justifyContent="center"
          >
            <ViewBtn
              disabled={!permissionCheck([PERMISSIONS.VIEW_WAREHOUSETRANSFEREXPORT_ALL, PERMISSIONS.VIEW_WAREHOUSETRANSFEREXPORT_OWN])}
              handleView={handleView}
            />
            {item?.totalQty !== item?.totalExported && (
              <UpdateBtn
                handleUpdate={handleUpdate}
                disabled={
                  item?.statusOut === orderStatusFormatted.Exported ||
                  !permissionCheck([PERMISSIONS.UPDATE_WAREHOUSETRANSFEREXPORT_ALL, PERMISSIONS.UPDATE_WAREHOUSETRANSFEREXPORT_OWN])
                }
              />
            )}

            <PrintBtn handlePrint={handlePrint} />
            {item?.totalQty !== item?.totalExported && (
              <DeleteBtn
                disabled={
                  item?.statusOut === orderStatusFormatted.Exported ||
                  !permissionCheck([PERMISSIONS.DELETE_WAREHOUSETRANSFEREXPORT_ALL, PERMISSIONS.DELETE_WAREHOUSETRANSFEREXPORT_OWN])
                }
                handleDelete={handleDeleteDialog}
              />
            )}
          </Box>
        );
      default:
        return (
          <Box
            display="flex"
            gap="6px"
            justifyContent="center"
          >
            <ViewBtn
              handleView={handleView}
              disabled={!permissionCheck([PERMISSIONS.VIEW_WAREHOUSETRANSFEREXPORT_ALL, PERMISSIONS.VIEW_WAREHOUSETRANSFEREXPORT_OWN])}
            />
            <UpdateBtn
              handleUpdate={handleUpdate}
              disabled={
                item?.statusOut === orderStatusFormatted.Exported ||
                !permissionCheck([PERMISSIONS.UPDATE_WAREHOUSETRANSFEREXPORT_ALL, PERMISSIONS.UPDATE_WAREHOUSETRANSFEREXPORT_OWN])
              }
            />
            <PrintBtn handlePrint={handlePrint} />
            <DeleteBtn
              disabled={
                item?.statusOut === orderStatusFormatted.Exported ||
                !permissionCheck([PERMISSIONS.DELETE_WAREHOUSETRANSFEREXPORT_ALL, PERMISSIONS.DELETE_WAREHOUSETRANSFEREXPORT_OWN])
              }
              handleDelete={handleDeleteDialog}
            />
          </Box>
        );
    }
  };

  return action();
}
